export const ORGANIZATIONS_TEXTS = {
  title: 'Organisations',
  addOrganization: 'Ajouter une organisation',
  updateOrganization: 'Modifier l\'organisation',
  name: 'Nom',
  createdAt: 'Date de création',
  updatedAt: 'Date de modification',
  loading: 'Chargement des organisations...',
  errorLoading: 'Erreur lors du chargement des organisations',
  noOrganizations: 'Aucune organisation trouvée',
  // Configuration section
  configsSection: 'Configuration',
  inactiveSensorThreshold: 'Seuil d\'inactivité des capteurs (minutes)',
  inactiveLocationThreshold: 'Seuil d\'inactivité des emplacements (minutes)',
  addressBookLimit: 'Limite du carnet d\'adresses',
  conditionsLimit: 'Maximum de conditions par alerte',
  // Contact section
  contactSection: 'Contact',
  contactEmails: 'Emails de contact',
  contactSms: 'Numéros SMS',
  addEmail: 'Ajouter un email',
  addSms: 'Ajouter un numéro',
  emailPlaceholder: 'email@exemple.com',
  smsPlaceholder: '+33612345678',
  errors: {
    ORGANIZATION_NAME_REQUIRED: 'Le nom de l\'organisation est requis',
    ORGANIZATION_ID_REQUIRED: 'L\'ID de l\'organisation est requis',
    ORGANIZATION_NAME_EMPTY: 'Le nom de l\'organisation ne peut pas être vide',
    ORGANIZATION_NAME_TOO_SHORT: 'Le nom de l\'organisation doit contenir au moins 2 caractères',
    ORGANIZATION_NAME_TOO_LONG: 'Le nom de l\'organisation ne peut pas dépasser 100 caractères',
    CONFIG_VALUE_NOT_POSITIVE: 'Doit être un nombre positif',
    ADDRESS_BOOK_LIMIT_INVALID: 'Doit être un entier supérieur ou égal à 1',
    CONDITIONS_LIMIT_INVALID: 'Doit être un entier entre 1 et 50',
    EMAIL_FORMAT_INVALID: 'Format email invalide',
    PHONE_FORMAT_INVALID: 'Format de numéro invalide',
    CREATE_ORGANIZATION_FAILED: 'Échec de la création de l\'organisation',
    UPDATE_ORGANIZATION_FAILED: 'Échec de la modification de l\'organisation'
  },
  documentDialog: {
    title: 'Document JSON de l\'organisation',
    organizationLabel: 'Organisation :',
    description: 'Visualisation du document complet de l\'organisation en format JSON'
  }
} as const;
